import axios from 'axios'
import { baseURL } from "../config/apiBase"

class RegisterService {
    createRecruteur(d) {
        let formData = new FormData();

        for (var key of Object.keys(d)) {
            formData.append(key, d[key]);
        }

        return axios.post(
            baseURL + 'recruteur/register', formData, {
                headers: {
                    "Content-Type": "multipart/form-data"
                },
        })
        .then(response => {
            return response.data;
        });
    }


    createPrestataire(d) {
        let formData = new FormData();

        Object.keys(d).forEach(key => {
            // Ne pas envoyer les valeurs null ou undefined
            if (d[key] !== null && d[key] !== undefined) {
            formData.append(key, d[key]);
            }
        });

        return axios.post(
            baseURL + 'prestataire/register',
            formData
        ).catch(error => {
            return Promise.reject(error);
        });
    }


}

export default new RegisterService();